// Antrean Desain Bordir Shopee: batas kirim (TANGGAL WIB) terdekat → paling lama menunggu; tanpa batas kirim di akhir.
const shipDayWIB = (iso) => {
  const t = iso ? Date.parse(iso) : NaN;
  return Number.isNaN(t) ? "" : new Date(t + 7 * 3600 * 1000).toISOString().slice(0, 10);
};
export const byShipDeadlineThenWait = (a, b) => {
  const da = shipDayWIB(a?.shopee_deadline_iso), db = shipDayWIB(b?.shopee_deadline_iso);
  if (da !== db) return !da ? 1 : !db ? -1 : (da < db ? -1 : 1);
  return (Date.parse(a?.bordir_forwarded_at) || 0) - (Date.parse(b?.bordir_forwarded_at) || 0);
};
